import {Inject, Injectable} from '@angular/core';
import {UserModel} from '../../../modules/auth/_models/user.model';
import {OKTA_AUTH, OktaAuthStateService} from '@okta/okta-angular';
import {Observable} from 'rxjs';
import {AuthState, OktaAuth} from '@okta/okta-auth-js';
import {filter, map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private user: UserModel = new UserModel();

    constructor(
        private _oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth,
        private http: HttpClient,
    ) { }

    public getConnectedUser(): Observable<UserModel> {
        return this._oktaAuthStateService.authState$.pipe(
            filter((authState: AuthState) => !!authState && !!authState.isAuthenticated),
            map((authState: AuthState) => {
                {
                    this.user.email = authState.idToken?.claims.email ?? '';
                    this.user.firstname = authState.idToken?.claims.name ?? '';
                    this.user.lastname = authState.idToken?.claims.family_name ?? '';
                    return this.user;
                }
            })
        ) as Observable<UserModel>;
    }

    public isAuthenticated: Observable<boolean> = this._oktaAuthStateService.authState$.pipe(
        map((authState: AuthState) => !!authState && !!authState.isAuthenticated)
    );

    logout() {
        this._oktaAuth.signOut()
    }

    handleTokenExpired() {
        this._oktaAuth.signOut();
    }

}
